import { Service, inject } from '@angular/core'
import {
  AuthLoginBody,
  AuthRegisterBody,
  AuthRegisterEntityBody,
  ChangePasswordBody,
  ConfirmEmailChangeBody,
  LoginResponse,
  RequestEmailChangeBody,
  ResetPasswordBody,
  SetNewPasswordBody,
  SuccessResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class AuthApiService {
  private readonly api = inject(ApiService)

  signup(body: AuthRegisterBody, init?: RequestInit) {
    return this.api.fetchJson<LoginResponse>(`auth/signup`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  signin(body: AuthLoginBody, init?: RequestInit) {
    return this.api.fetchJson<LoginResponse>(`auth/signin`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  registerEntity(body: AuthRegisterEntityBody, init?: RequestInit) {
    return this.api.fetchJson<LoginResponse>(`auth/register-entity`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  resetPassword(body: ResetPasswordBody, init?: RequestInit) {
    return this.api.fetchJson<SuccessResponse>(`auth/reset-password`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  setNewPassword(body: SetNewPasswordBody, init?: RequestInit) {
    return this.api.fetchJson<SuccessResponse>(`auth/set-new-password`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  /** Môj profil: answers a fresh token for this session; every other session ends. */
  changePassword(body: ChangePasswordBody, init?: RequestInit) {
    return this.api.protectedFetchJson<LoginResponse>(`auth/change-password`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  /** Môj profil: a link goes to the new address; the account changes only once it is opened. */
  requestEmailChange(body: RequestEmailChangeBody, init?: RequestInit) {
    return this.api.protectedFetchJson<SuccessResponse>(`auth/email-change`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  cancelEmailChange(init?: RequestInit) {
    return this.api.protectedFetchJson<SuccessResponse>(`auth/email-change`, { method: 'DELETE', ...init })
  }

  /** The confirmation link's page. Public: it may be opened where nobody is signed in. */
  confirmEmailChange(body: ConfirmEmailChangeBody, init?: RequestInit) {
    return this.api.fetchJson<SuccessResponse>(`auth/confirm-email-change`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
